import React from "react";

export default function Loading({ loading }) {
  if (!loading) return null;

  return (
    <p>
      <i className="fa fa-spinner fa-spin"></i>&nbsp; Loading...
    </p>
  );
}
